export const theme = {
  colors: {
    btnСolorText: '#0b0c0', // колір кнопок #0b0c0
    backgroundColorsPrimary: '#ffffff', // колір фону #0b0c10
    backgroundColors: '#c0e8f0', // колір фону карток
    colorText: 'black', // колір тексту #45a29e
    colorElement: '#greyish', // колір інпутів #66fcf1
    // colorAccent: '#66fcf1',
    // secondaryText: '#red',
    white: '#black', // колір тексту списку
  },
  boxShadow: '1px 1px 4px 1px rgba(69,  162,  158, 0.93)',
  sectionShadow: '0px 0px 19px 0px #66fcc3', // основний колір тіні gba(69, 162, 158, 1)
  insideShadow: 'inset 0px 0px 19px 0px #66fcc3', // основний колір тіні gba(69, 162, 158, 1)
};
